import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function NameList({ onCsvData }: any) {
  const [csvData, setCsvData] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchCSVData = () => {
      const csvUrl = process.env.REACT_APP_GOOGLE_SHEET_URL;
      axios
        .get(csvUrl!)
        .then((response) => {
          const parsedCsvData = parseCSV(response.data);
          setCsvData(parsedCsvData as any);
        })
        .catch((error) => {
          console.error("Error fetching CSV data:", error);
        });
    };

    fetchCSVData();
    onCsvData(csvData.length);
  }, [csvData.length, onCsvData, t]);

  function parseCSV(csvText: any) {
    const rows = csvText.split(/\r?\n/); // Split CSV text into rows, handling '\r' characters
    const data = []; // Initialize an array to store parsed data
    for (let i = 1; i < rows.length; i++) {
      const rowData = rows[i].split(","); // Split the row, handling '\r' characters
      rowData.shift();
      const filteredRowData = rowData.filter((item: string) => item);
      const joinedData = filteredRowData.join(", ");
      data.push(joinedData);
    }
    return data;
  }

  return (
    <div className="name-list-section">
      <h1>
        {csvData.length} {t("signatures")}
      </h1>
      <ol className="name-list">
        {csvData.map((row: any, i) => (
          <li key={i}>{row}</li>
        ))}
      </ol>
    </div>
  );
}
